export default "__VITE_ASSET__D35OsY_d__"